



































































































































































































































































































































import { Component, Watch, Prop, Emit } from 'vue-property-decorator';

import BrandAndModel from './conditions/brand-and-model.vue';
import BrowserAndVersion from './conditions/browser-and-version.vue';
import OsAndVersion from './conditions/os-and-version.vue';
import Dictionary from './conditions/dictionary.vue';
import ConnectionType from './conditions/connection-type.vue';
import Custom from './conditions/custom.vue';
import CustomToken from './conditions/custom-token.vue';
import QueryHeader from './conditions/query-header.vue';
import DayOfWeek from './conditions/day-of-week.vue';
import DeviceType from './conditions/device-type.vue';
import Ip from './conditions/ip.vue';
import Referrer from './conditions/referrer.vue';
import ReferrerDomain from './conditions/referrer-domain.vue';
import UserAgent from './conditions/user-agent.vue';
import TimeOfDay from './conditions/time-of-day.vue';
import Timezone from './conditions/timezone.vue';
import Webview from './conditions/webview.vue';
import Uniqueness from './conditions/uniqueness.vue';
import UniqOfferViewer from './conditions/uniq-offer-viewer.vue';
import BotFilter from './conditions/bot-filter.vue';
import Crawler from './conditions/crawler.vue';
import Proxy from './conditions/proxy.vue';
import VisitCap from './conditions/visit-cap.vue';
import IpBlacklisted from './conditions/ip-blacklisted.vue';
import IpDataCenter from './conditions/ip-data-center.vue';
import IpWithFrequentEvents from '@/views/reports/forms/flow/views/conditions/ip-with-frequent-events.vue';
import IpWithFrequentCampaignEvents from '@/views/reports/forms/flow/views/conditions/ip-with-frequent-campaign-events.vue';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import ExternalId from './conditions/external-id.vue';

@Component({
  components: {
    ExternalId,
    BrandAndModel,
    BrowserAndVersion,
    OsAndVersion,
    Dictionary,
    ConnectionType,
    Custom,
    CustomToken,
    QueryHeader,
    DayOfWeek,
    DeviceType,
    Ip,
    Referrer,
    UserAgent,
    TimeOfDay,
    Uniqueness,
    UniqOfferViewer,
    BotFilter,
    Timezone,
    Webview,
    ReferrerDomain,
    Crawler,
    Proxy,
    VisitCap,
    IpBlacklisted,
    IpDataCenter,
    IpWithFrequentEvents,
    IpWithFrequentCampaignEvents,
  },
})
export default class RuleSettings  extends mixins<PlanLimitsMixin>(PlanLimitsMixin) {
  @Prop()
  rule: any;

  @Prop()
  ruleIndex: number;

  @Prop()
  placeholder: string;

  @Prop({ default: () => {} })
  errorsDict: any;

  @Emit('duplicate')
  onDuplicate(rule: any) {}

  @Emit('delete')
  onDelete(rule: any) {}

  get defaultConditions():Array<Rules.condition> {
    const result  = [
      { name: this.t('Brand and Model'), condition: 'brand' },
      { name: this.t('Browser and Version'), condition: 'browser' },
      { name: this.t('Connection Type'), condition: 'connectType' },
      { name: this.t('Country'), condition: 'country' },
      { name: this.t('State / Region'), condition: 'state' },
      { name: this.t('City'), condition: 'city' },
      { name: this.t('Custom Token'), condition: 'customToken' },
      { name: this.t('Query Header'), condition: 'queryHeader' },
      { name: this.t('Custom 1'), condition: 'custom1' },
      { name: this.t('Custom 2'), condition: 'custom2' },
      { name: this.t('Custom 3'), condition: 'custom3' },
      { name: this.t('Custom 4'), condition: 'custom4' },
      { name: this.t('Custom 5'), condition: 'custom5' },
      { name: this.t('Custom 6'), condition: 'custom6' },
      { name: this.t('Custom 7'), condition: 'custom7' },
      { name: this.t('Custom 8'), condition: 'custom8' },
      { name: this.t('Custom 9'), condition: 'custom9' },
      { name: this.t('Custom 10'), condition: 'custom10' },
      { name: this.t('Day of Week'), condition: 'dayOfWeek' },
      { name: this.t('Device Type'), condition: 'deviceType' },
      { name: this.t('IP'), condition: 'ip' },
      { name: this.t('ISP'), condition: 'isp' },
      { name: this.t('Language'), condition: 'language' },
      { name: this.t('Mobile Carrier'), condition: 'mobileCarrier' },
      { name: this.t('OS and Version'), condition: 'os' },
      { name: this.t('Referrer'), condition: 'referrer' },
      { name: this.t('Referrer Domain'), condition: 'referrerDomain' },
      { name: this.t('Time of Day'), condition: 'timeOfDay' },
      { name: this.t('User Agent'), condition: 'userAgent' },
      { name: this.t('Uniqueness'), condition: 'uniqueness' },
      { name: this.t('Recurring Conversion'), condition: 'uniqOfferViewer' },
      { name: this.t('Bot Filter Marks'), condition: 'botMark' },
      { name: this.t('WebView'), condition: 'webViewMark' },
      { name: this.t('Crawler'), condition: 'crawler' },
      { name: this.t('Proxy'), condition: 'proxy' },
      { name: this.t('Visits Cap'), condition: 'visitCap' },
      { name: this.t('Suspicious Traffic (blacklisted IPs)'), condition: 'ipBlacklisted' },
      { name: this.t('Suspicious Traffic (data centres IPs)'), condition: 'ipDataCenter' },
      { name: this.t('Suspicious Traffic (Frequent Events)'), condition: 'ipWithFrequentEvents' },
      { name: this.t('Suspicious Traffic (Frequent Campaign Events)'), condition: 'ipWithFrequentCampaignEvents' },
      { name: this.t('External ID'), condition: 'externalId' },
    ]

    // if(this.$FF.visitsCapEnabled){
    //   result.push({ name: this.t('Visits Cap'), condition: 'visitCap' })
    // }
    return result
  }

  conditions: Array<Rules.condition> = [];
  created(){
    this.conditions = this.defaultConditions;
  }

  get isTimezoneAvailable() {
    return this.selectedDictionary['timeOfDay'] || this.selectedDictionary['dayOfWeek'];
  }

  get isClientHintsNoticeVisible() {
    return Object.keys(this.rule.conditions).some((item)=>[ 'os', 'browser', 'deviceType','brand' ].includes(item))
  }

  get customConditions() {
    return Array.apply(null, { length: 10 } as any)
      .map((value, index) => index + 1)
      .filter((item) => {
        return this.selectedDictionary['custom' + item]
      });
  }

  add(item: any) {
    let index = this.conditions.indexOf(item);
    if (index !== -1) {
      this.conditions[index].selected = true;
      this.$set(this.conditions, index, this.conditions[index]);
    }
  }

  @Watch('rule.logicalRelation', {
    immediate: true
  })
  onChangeRuleLogicalRelation(value: string, oldValue: string) {
    if(!value) {
      this.$set(this.rule, 'logicalRelation', 'and');
    }
  }

  @Watch('rule', {
    immediate: true
  })
  onRuleChanged(value: any, oldValue: any) {
    if(value !== oldValue) {
      this.conditions = this.defaultConditions;
    }
  }

  @Watch('rule.conditions', {
    immediate: true
  })
  changeConditions(value: any, oldValue: any) {
    if(!value) {
      return;
    }

    const rules = Object.keys(value);

    this.conditions.forEach((item, index) => {
      let hasRule = rules.indexOf(item.condition) !== -1;
      this.$set(this.conditions[index], `selected`, hasRule)
    });
  }

  remove(name: any) {
    let item = this.conditions.find((e: any) => e.selected && e.condition === name);
    if (item) {
      item.selected = false;
    }

    this.$delete(this.rule.conditions, name);

    if(!this.isTimezoneAvailable && this.rule.conditions.timezone) {
      this.$delete(this.rule.conditions, 'timezone');
    }
  }

  get selectedDictionaryEmpty() {
    const keys = Object.keys(this.selectedDictionary);
    return !keys.length;
  }

  get selectedDictionary() {
    let result: any = {};

    this.selectedConditions.forEach((item: any) => {
      result[item.condition] = true;
    });

    return result;
  }

  get selectedConditions() {
    return this.conditions
      .filter((e: any) => e.selected);
  }

  get notSelectedConditions() {
    return this.conditions
      .filter((e: any) => !e.selected);
  }

  get menuList() {
    return this.notSelectedConditions
      .map<Bemob.ListItem>((item) => ({
        key: item.condition,
        title: item.name,
        planLimits: this.conditionPlanLimits(item.condition),
        click: () => this.add(item)
      }));
  }

  deselect_all() {
    this.conditions.forEach((e: any) => {
      e.selected = false;
    });

    this.rule.conditions = {};
  }

  get rule_active() {
    return this.rule.status === 'active';
  }

  set rule_active(val: boolean) {
    if (val) {
      this.rule.status = 'active';
    } else {
      this.rule.status = 'inactive';
    }
  }
}
